export default __webpack_public_path__ + "static/media/ic_arrow_right_active.02f90959.svg";